<template>
  <Toast />

  <ConfirmPopup></ConfirmPopup>
  <div class="provider-view">
    <div class="header-section">
      <div class="header-content">
        <div class="title-section">
          <h1 class="title">Provider Assets</h1>
          <span class="catalog-badge">Connector Catalog</span>
        </div>
        <div style="margin-left: auto">
          <button
            class="btn-header btn-primary-asset"
            @click="$emit('add-asset')"
          >
            <svg class="i" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 5v14M5 12h14" />
            </svg>
            Add Asset
          </button>
        </div>
      </div>
    </div>

    <div class="filter-bar">
      <div class="filter-label">Filter</div>
      <div class="filter-group">
        <button
          class="filter-btn"
          :class="{ active: sourceView === 'all' }"
          @click="switchSource('all')"
        >
          <i class="pi pi-layer-group"></i>
          All
        </button>
        <button
          class="filter-btn"
          :class="{ active: sourceView === 'store' }"
          @click="switchSource('store')"
        >
          <i class="pi pi-box"></i>
          Store
          <span class="filter-count">{{ storeAssets.length }}</span>
        </button>
        <button
          class="filter-btn"
          :class="{ active: sourceView === 'connector' }"
          @click="switchSource('connector')"
        >
          <i class="pi pi-database"></i>
          Connector
          <span class="filter-count">{{ providerAssets.length }}</span>
        </button>
      </div>
    </div>

    <section class="assets-section">
      <div v-if="visibleAssets.length" class="assets-grid">
        <div v-for="item in visibleAssets" :key="item.key" class="asset-card">
          <div class="card-header">
            <div class="asset-info">
              <div class="asset-header">
                <h3 class="asset-id">{{ getAssetName(item) }}</h3>
                <button
                  v-if="item.store"
                  class="delete-icon"
                  @click="confirm2($event, item.store)"
                  aria-label="Delete asset"
                >
                  <svg viewBox="0 0 24 24">
                    <path
                      d="M3 6h18M8 6V4h8v2M6 6l1 14a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-14"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
              <div class="asset-meta">
                <span
                  v-if="item.store && item.connector"
                  class="source-tag source-tag--ok"
                >
                  Store
                </span>
                <span
                  v-if="item.store && item.connector"
                  class="source-tag source-tag--ok"
                >
                  Connector
                </span>
                <span
                  v-if="item.store && !item.connector"
                  class="source-tag source-tag--bad"
                >
                  Store
                </span>
                <span
                  v-if="item.connector && !item.store"
                  class="source-tag source-tag--ok"
                >
                  Connector
                </span>
                <!-- <span
                  v-if="item.connector && !item.store"
                  class="source-tag source-tag--bad"
                >
                  In Store
                </span> -->
              </div>
            </div>
          </div>

          <p class="asset-description">
            {{ getAssetDescription(item) }}
          </p>

          <div class="card-actions">
            <button
              v-if="item.store && !isPublished(item)"
              class="btn btn-secondary store-edit-btn"
              @click="emit('edit-asset', item.store.contentData, item.store)"
            >
              <svg class="btn-icon" viewBox="0 0 24 24">
                <path
                  d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                />
                <path
                  d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                />
              </svg>
              Edit Asset
            </button>
            <button
              v-if="item.store && isPublished(item)"
              class="btn btn-secondary action-button"
              @click="disabledButton()"
            >
              <svg class="btn-icon" viewBox="0 0 24 24">
                <path
                  d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                />
                <path
                  d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                />
              </svg>
              Edit Asset
            </button>
            <button
              class="btn btn-secondary"
              @click="emit('view-asset', item.store.contentData, item.store)"
            >
              <i class="pi pi-eye"></i>
              View Asset
            </button>
            <button
              v-if="item.connector && !item.store"
              class="btn btn-primary"
              @click="pushToStore(item.connector)"
            >
              Push to Store
            </button>
          </div>
        </div>
      </div>

      <div v-else class="empty-state">
        <div class="empty-icon">
          <i
            class="pi"
            :class="{
              'pi-box': sourceView === 'store',
              'pi-folder': sourceView === 'connector',
              'pi-layer-group': sourceView === 'all',
            }"
            style="font-size: 3rem; color: #a0aec0"
          ></i>
        </div>
        <h3 class="empty-title">{{ emptyTitle }}</h3>
        <p class="empty-description">{{ emptyDescription }}</p>
        <button
          v-if="sourceView === 'connector'"
          class="btn btn-primary empty-action"
          @click="$emit('add-asset')"
        >
          <svg class="btn-icon" viewBox="0 0 24 24">
            <path d="M12 5v14m-7-7h14" />
          </svg>
          Create First Asset
        </button>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, onMounted, computed, watch } from "vue";
import { useConfirm } from "primevue/useconfirm";
import ConfirmPopup from "primevue/confirmpopup";
import axios from "axios";
import { getCurrentInstance } from "vue";
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";

const { appContext } = getCurrentInstance();
const API_BASE_URL = appContext.config.globalProperties.$apiBase;
const confirm = useConfirm();
const toast = useToast();

const props = defineProps({
  providerAssets: {
    type: Array,
    default: () => [],
  },
  contractDefinitions: {
    type: Array,
    default: () => [],
  },
  storeAssets: {
    type: Array,
    default: () => [],
  },
  storeOffers: {
    type: Array,
    default: () => [],
  },
  user: {
    type: String,
    default: "",
  },
  initialSource: {
    type: String,
    default: "all",
  },
  mergedAssets: {
    type: Array,
    default: () => [],
  },
});

const testFunction = () => {
  console.log("Testing function called");
  console.log("Provider Assets:", props.providerAssets);
  console.log("Store Assets:", props.storeAssets);
};

const emit = defineEmits([
  "edit-asset",
  "view-asset",
  "add-asset",
  "refresh-assets",
  "asset-created",
]);

const sourceView = ref(props.initialSource || "all");

const switchSource = (view) => {
  sourceView.value = view;
};

watch(
  () => props.initialSource,
  (next) => {
    if (next && next !== sourceView.value) {
      sourceView.value = next;
    }
  }
);

const totalAssets = computed(
  () => props.storeAssets.length + props.providerAssets.length
);

const getStoreId = (asset) =>
  asset?.externalId || asset?.contentData?.["@id"] || asset?.id;
const getStoreName = (asset) => asset?.name || asset?.contentData?.name;
const getConnectorId = (asset) => asset?.id || asset?.properties?.id;
const getConnectorName = (asset) => asset?.properties?.name;

const storeById = computed(() => {
  const map = new Map();
  props.storeAssets.forEach((asset) => {
    const key = getStoreId(asset);
    if (key) map.set(key, asset);
  });
  return map;
});

const storeByName = computed(() => {
  const map = new Map();
  props.storeAssets.forEach((asset) => {
    const key = getStoreName(asset);
    if (key) map.set(key, asset);
  });
  return map;
});

const connectorById = computed(() => {
  const map = new Map();
  props.providerAssets.forEach((asset) => {
    const key = getConnectorId(asset);
    if (key) map.set(key, asset);
  });
  return map;
});

const connectorByName = computed(() => {
  const map = new Map();
  props.providerAssets.forEach((asset) => {
    const key = getConnectorName(asset);
    if (key) map.set(key, asset);
  });
  return map;
});

const findConnectorForStore = (asset) => {
  const id = getStoreId(asset);
  if (id && connectorById.value.has(id)) return connectorById.value.get(id);
  const name = getStoreName(asset);
  if (name && connectorByName.value.has(name))
    return connectorByName.value.get(name);
  return null;
};

const findStoreForConnector = (asset) => {
  const id = getConnectorId(asset);
  if (id && storeById.value.has(id)) return storeById.value.get(id);
  const name = getConnectorName(asset);
  if (name && storeByName.value.has(name)) return storeByName.value.get(name);
  return null;
};

const storeViewAssets = computed(() =>
  props.storeAssets.map((asset) => {
    const key = getStoreId(asset) || getStoreName(asset);
    return {
      key: key || asset.id,
      store: asset,
      connector: findConnectorForStore(asset),
    };
  })
);

const connectorViewAssets = computed(() =>
  props.providerAssets.map((asset) => {
    const key = getConnectorId(asset) || getConnectorName(asset);
    return {
      key: key || asset.id,
      store: findStoreForConnector(asset),
      connector: asset,
    };
  })
);

const normalizeAssetItem = (item) => ({
  ...item,
  connector: item.connector
    ? {
        ...item.connector,
        properties: cleanKeys(item.connector.properties),
      }
    : item.connector,
});

const visibleAssets = computed(() => {
  if (sourceView.value === "all") {
    return props.mergedAssets.map(normalizeAssetItem);
  }

  if (sourceView.value === "store") {
    return storeViewAssets.value.map(normalizeAssetItem);
  }

  return connectorViewAssets.value.map(normalizeAssetItem);
});

const getAssetName = (item) =>
  item.store?.name ||
  item.connector?.properties?.name ||
  item.connector?.id ||
  "Unnamed asset";

const getAssetDescription = (item) =>
  item.store?.description ||
  item.connector?.properties?.description ||
  "No description provided";

const isPublished = (item) =>
  Boolean(item.connector || item.store?.metadata?.additionalProp1?.inConnector);

const emptyTitle = computed(() => {
  if (sourceView.value === "store") return "No assets in store";
  if (sourceView.value === "connector") return "No assets published yet";
  return "No assets available";
});

const emptyDescription = computed(() => {
  if (sourceView.value === "store") {
    return "Store assets will appear here once the store database is connected.";
  }
  if (sourceView.value === "connector") {
    return "Create your first asset to make it available to consumers.";
  }
  return "Once assets are added, they will appear here from both sources.";
});

const cleanKeys = (data) => {
  if (typeof data == "object") {
    let newCatalogData = {};
    for (const [key, value] of Object.entries(data)) {
      let newKey = "";
      if (key.includes("https://example.org/ds2/vocab#")) {
        newKey = key.split("vocab#")[1];
      } else {
        newKey = key;
      }
      newCatalogData[newKey] = cleanKeys(value);
    }
    return newCatalogData;
  } else return data;
};

const replaceKeys = (data) => {
  if (typeof data == "object") {
    let newCatalogData = {};
    for (const [key, value] of Object.entries(data)) {
      let newKey = "";
      if (key.includes("https://example.org/ds2/vocab#")) {
        newKey = key.replace("https://example.org/ds2/vocab#", "ds2:");
      } else if (key.includes("ds2:")) {
        newKey = key;
      } else {
        newKey = "ds2:" + key;
      }
      newCatalogData[newKey] = replaceKeys(value);
    }
    return newCatalogData;
  } else return data;
};

const pushToStore = async (asset) => {
  asset.properties = replaceKeys(asset.properties);

  const assetStorePayload = {
    ownerId: props.user,
    externalId: asset["@id"],
    objectType: { name: "Asset", level: 0 },
    name: asset.properties["ds2:name"],
    description: asset.properties["ds2:description"] || "",
    comments: asset.properties.comments || "",
    version: asset.properties["ds2:assetVersion"] || "1.0",
    tags: asset.properties.tags,
    metadata: {
      additionalProp1: {
        inConnector: true,
      },
    },
    contentType: "json",
    contentData: asset,
  };

  console.log("Pushing asset to store:", assetStorePayload);
  const response = await axios.post(
    `${API_BASE_URL}/repository/insert`,
    assetStorePayload,
    {
      params: {
        "API-KEY": "C5CC3F19",
      },
      headers: {
        Accept: "application/json",
        "API-KEY": "C5CC3F19",
      },
    }
  );

  console.log("Response from asset store: ", response.data);

  if (response.data.acknowledged) {
    // Reset form and notify parent
    setTimeout(() => {
      emit("asset-created");
    }, 1500);
    //emit("update:modelValue", "subscriber");
  } else {
    throw new Error(response.data.error || "Failed to register asset");
  }
};

const disabledButton = () => {
  toast.add({
    severity: "warn",
    summary: "Warning Message",
    detail: "This asset is already published and cannot be edited.",
    life: 5000,
  });
};

const confirm2 = (event, asset) => {
  confirm.require({
    target: event.currentTarget,
    message: "Do you want to delete this record?",
    icon: "pi pi-info-circle",
    rejectProps: {
      label: "Cancel",
      severity: "secondary",
      outlined: true,
    },
    acceptProps: {
      label: "Delete",
      severity: "danger",
    },
    accept: async () => {
      try {
        console.log("Asset to delete:", asset);

        console.log("Visible assets: ", visibleAssets.value);

        const selectedAsset = visibleAssets.value.find(
          (a) => a.key === asset.externalId
        );

        console.log("Selected asset for deletion:", selectedAsset);
        console.log("Selected asset id: ", selectedAsset.key);

        if (selectedAsset.connector) {
          const response = await axios.delete(
            `${API_BASE_URL}/provider/assets/${selectedAsset.key}`
          );
          console.log("Response from provider API:", response.data);
          if (response.data.success) {
            await axios.delete(
              `${API_BASE_URL}/repository/delete/${selectedAsset.store.id}`,
              {
                params: {
                  file_id: selectedAsset.store.id, // required query param
                },
              }
            );
            emit("refresh-assets");
            return;
          }
        } else {
          await axios.delete(
            `${API_BASE_URL}/repository/delete/${selectedAsset.store.id}`,
            {
              params: {
                file_id: selectedAsset.store.id, // required query param
              },
            }
          );
          emit("refresh-assets");
          return;
        }
      } catch (error) {
        const errormsg = error.response?.data?.detail?.[0]?.message;
        console.error("Failed to delete asset:", errormsg);
        toast.add({
          severity: "error",
          summary: "Error Message",
          detail: errormsg,
          life: 5000,
        });
      }
    },
  });
};
</script>

<style scoped src="../assets/provider-view.css"></style>
